var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { LoginBaseModel } from './login-base-model';
// PATH
// /ws/user/sign/up
// SUCCESS
// 200
// null
// ERROR
// 400
// {"error": {"message": "This email address is already in use. <br/>Current users, please sign in.", "code": 400, "arguments": null}}
var SignUpModel = /** @class */ (function (_super) {
    __extends(SignUpModel, _super);
    function SignUpModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.version = 2;
        return _this;
    }
    SignUpModel.toJSON = function (value) {
        return {
            version: value.version,
            email: value.email,
            password: value.password,
            first_name: value.firstName,
            last_name: value.lastName,
            // Required
            group_invite_mode: value.groupInviteMode,
            group_invite_key: value.groupInviteKey,
            group_code_mode: value.groupCodeMode,
            group_code: value.groupCode
        };
    };
    return SignUpModel;
}(LoginBaseModel));
export { SignUpModel };
